/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_DetailsInputs */

const en_lesson_details = /** @type {(inputs: Lesson_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const he_lesson_details = /** @type {(inputs: Lesson_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרטים`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Lesson_DetailsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_details = /** @type {((inputs?: Lesson_DetailsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_DetailsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_details(inputs)
	return he_lesson_details(inputs)
});